import { AchievementService } from '../../services/AchievementService';
import QRCode from 'qrcode';
import { ApiClient } from '../../services/ApiClient';
import { AuthStore, AVATARS_LIST } from '../../core/store/authStore';
import { ToastManager } from '../components/Toast';
import { GAME_REGISTRY } from '../../engine/GameRegistry';

export class ProfileView {
  private static achTab: 'unlocked' | 'locked' = 'unlocked';
  private static activeAchGame: string = 'all';
  private static achPage = 1;
  private static readonly achPerPage = 9;

  static async render(container: HTMLElement): Promise<void> {
    const user = AuthStore.getUser() || {
      id: 'guest',
      username: 'Misafir Oyuncu',
      tag: '#0000',
      avatarUrl: '🍌',
      role: 'user',
    };

    const achievements = AchievementService.getAchievements();
    const unlockedCount = AchievementService.getUnlockedCount();
    const totalCount = achievements.length;
    const progressPercent = Math.round((unlockedCount / totalCount) * 100);

    // Seviye ve Unvan Hesaplama
    const level = Math.floor(unlockedCount / 3) + 1;
    let title = 'Çaylak';
    if (level >= 5) title = 'Deneyimli';
    if (level >= 10) title = 'Uzman';
    if (level >= 20) title = 'Usta';
    if (level >= 30) title = 'Efsane';
    if (level >= 40) title = 'Arcade Tanrısı';

    // Fetch real stats
    let totalPlayed = 0;
    let highestScoreText = 'Henüz yok';
    let highestScoreVal = 0;

    if (user.id !== 'guest') {
      const res = await ApiClient.getUserScores(user.id);
      if (res.data && res.data.length > 0) {
        const uniqueGames = new Set(res.data.map((s: any) => s.game_id));
        totalPlayed = uniqueGames.size;
        
        const topScore = res.data.reduce((prev: any, current: any) => (prev.score > current.score) ? prev : current);
        highestScoreVal = topScore.score;
        highestScoreText = `${topScore.score.toLocaleString()} (${topScore.game_id})`;
      }
    }

    const filteredAch = achievements.filter(a => {
      const matchTab = this.achTab === 'unlocked' ? a.unlocked : !a.unlocked;
      const matchGame = this.activeAchGame === 'all' || a.gameId === this.activeAchGame;
      return matchTab && matchGame;
    });
    const totalAchPages = Math.ceil(filteredAch.length / this.achPerPage);
    const startIdx = (this.achPage - 1) * this.achPerPage;
    const currentAch = filteredAch.slice(startIdx, startIdx + this.achPerPage);

    container.innerHTML = `
      <div style="max-width: 1000px; margin: 30px auto; padding: 0 20px; width: 100%;">
        <!-- QR & Badges Section -->
        <div id="qr-badges-container" style="display: flex; gap: 20px; margin-bottom: 20px; flex-wrap: wrap;">
          <div class="glass-panel" style="padding: 20px; text-align: center; flex: 1; min-width: 260px;">
            <h4 style="margin-bottom: 10px; font-weight: 800;">QR Arkadaş Kodu</h4>
            <div style="max-width: 200px; margin: 0 auto;">
              <canvas id="qr-canvas" style="border-radius: 8px; width: 100%;"></canvas>
            </div>
            <p style="font-size: 0.8rem; color: #94a3b8; margin-top: 10px;">Taratarak ekle</p>
          </div>
          <div class="glass-panel" style="flex: 1; padding: 20px; min-width: 260px;">
            <h4 style="margin-bottom: 10px; font-weight: 800;">Rozetler</h4>
            <div id="badges-list" style="display: flex; gap: 10px; flex-wrap: wrap;">
              <span style="color: #64748b; font-size: 0.9rem;">Rozetler Yükleniyor...</span>
            </div>
          </div>
        </div>

        
        <!-- Profil Başlık Kartı -->
        <div class="glass-panel" style="padding: 28px; border-radius: 20px; display: flex; align-items: center; justify-content: space-between; gap: 24px; margin-bottom: 30px; flex-wrap: wrap;">
          <div style="display: flex; align-items: center; gap: 20px; flex-wrap: wrap;">
            <div id="change-avatar-btn" style="width: 80px; height: 80px; background: linear-gradient(135deg, #6366f1, #a855f7); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 2.8rem; border: 3px solid #f8fafc; box-shadow: 0 10px 25px rgba(99, 102, 241, 0.4); cursor: pointer; position: relative; flex-shrink: 0;" title="Avatarını Seç">
              ${user.avatarUrl || '🍌'}
              <span style="position: absolute; bottom: 0; right: 0; background: #6366f1; color: #fff; font-size: 0.65rem; font-weight: 800; padding: 2px 6px; border-radius: 10px; border: 1px solid #fff;">SEÇ</span>
            </div>

            <div>
              <div style="display: flex; align-items: center; gap: 8px;">
                <h2 style="font-size: 1.8rem; font-weight: 800;">${user.username}</h2>
                <span style="font-size: 1.1rem; color: #818cf8; font-weight: 800;">${user.tag || '#0000'}</span>
                ${user.role === 'admin' ? `<span style="background: linear-gradient(135deg, #a855f7, #6366f1); color: #fff; font-size: 0.72rem; font-weight: 800; padding: 3px 10px; border-radius: 12px;">👑 ADMIN</span>` : ''}
              </div>
              <p style="color: #94a3b8; font-size: 0.9rem; margin-top: 4px;">
                <span style="background: rgba(34, 197, 94, 0.2); color: #4ade80; padding: 2px 8px; border-radius: 8px; font-weight: 700; margin-right: 6px;">Seviye ${level}</span> 
                ${title}
              </p>
            </div>
          </div>

          <!-- Genel Başarım İlerleme Çubuğu -->
          <div style="width: 260px; display: flex; flex-direction: column; gap: 8px;">
            <div style="display: flex; justify-content: space-between; font-size: 0.85rem; font-weight: 700;">
              <span>Başarım İlerlemesi</span>
              <span style="color: #38bdf8;">${unlockedCount} / ${totalCount} (%${progressPercent})</span>
            </div>
            <div style="height: 10px; background: #0f172a; border-radius: 6px; overflow: hidden; border: 1px solid #334155;">
              <div style="height: 100%; width: ${progressPercent}%; background: linear-gradient(90deg, #6366f1, #22c55e); border-radius: 6px; transition: width 0.5s ease;"></div>
            </div>
          </div>
        </div>

        <!-- İstatistik Özet Kartları -->
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 20px; margin-bottom: 36px;">
          <div class="glass-panel" style="padding: 20px; text-align: center;">
            <span style="font-size: 2rem;">🎮</span>
            <h3 style="font-size: 1.8rem; font-weight: 800; color: #38bdf8; margin: 6px 0;">${totalPlayed}</h3>
            <p style="color: #94a3b8; font-size: 0.85rem;">Oynanan Farklı Oyun</p>
          </div>
          <div class="glass-panel" style="padding: 20px; text-align: center;">
            <span style="font-size: 2rem;">⚡</span>
            <h3 style="font-size: 1.8rem; font-weight: 800; color: #a855f7; margin: 6px 0;">${highestScoreVal > 0 ? highestScoreVal.toLocaleString() : '-'}</h3>
            <p style="color: #94a3b8; font-size: 0.85rem;">En Yüksek Skor: ${highestScoreText}</p>
          </div>
          <div class="glass-panel" style="padding: 20px; text-align: center;">
            <span style="font-size: 2rem;">🏆</span>
            <h3 style="font-size: 1.8rem; font-weight: 800; color: #22c55e; margin: 6px 0;">${unlockedCount} Kazanılan</h3>
            <p style="color: #94a3b8; font-size: 0.85rem;">Kilitli Başarımlar: ${totalCount - unlockedCount}</p>
          </div>
        </div>

        <!-- Başarımlar Listesi (Sayfalı Grid) -->
        <div class="glass-panel" style="padding: 24px; margin-bottom: 30px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; flex-wrap: wrap; gap: 16px;">
            <h3 style="font-size: 1.5rem; font-weight: 800;">🏆 Oyun Başarımları</h3>
            <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap; flex: 1; min-width: 260px; width: 100%;">
              <select id="ach-game-select" style="flex: 1; min-width: 200px; width: 100%; padding: 10px 14px; background: rgba(30, 41, 59, 0.8); border: 1px solid #334155; border-radius: 10px; color: #f8fafc; font-size: 0.88rem; outline: none; cursor: pointer;">
                <option value="all">Tüm Oyunlar</option>
                ${GAME_REGISTRY.map(g => `<option value="${g.id}" ${this.activeAchGame === g.id ? 'selected' : ''}>${g.title}</option>`).join('')}
              </select>
              <div style="display: flex; gap: 6px; background: rgba(30, 41, 59, 0.8); padding: 4px; border-radius: 12px; border: 1px solid #334155; flex: 1; min-width: 200px; width: 100%;">
                <button id="tab-ach-unlocked" style="flex: 1; padding: 10px 4px; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" class="ach-tab-btn ${this.achTab === 'unlocked' ? 'ach-tab-btn--active' : ''}">Açık (${unlockedCount})</button>
                <button id="tab-ach-locked" style="flex: 1; padding: 10px 4px; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" class="ach-tab-btn ${this.achTab === 'locked' ? 'ach-tab-btn--active' : ''}">Kilitli (${totalCount - unlockedCount})</button>
              </div>
            </div>
          </div>

          <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 16px;">
            ${currentAch.map(ach => `
              <div style="background: rgba(15, 23, 42, 0.6); border-radius: 12px; border: 1px solid #334155; padding: 16px; display: flex; align-items: center; gap: 16px; border-left: 4px solid ${ach.unlocked ? '#22c55e' : '#475569'}; ${!ach.unlocked ? 'opacity: 0.6; filter: grayscale(0.8);' : ''}">
                <div style="font-size: 2.2rem; min-width: 44px; text-align: center;">${ach.icon}</div>
                <div style="flex: 1;">
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    <h5 style="font-size: 0.98rem; font-weight: 700; color: ${ach.unlocked ? '#f8fafc' : '#94a3b8'};">${ach.title}</h5>
                  </div>
                  <p style="color: #94a3b8; font-size: 0.82rem; margin-top: 4px; line-height: 1.3;">${ach.description}</p>
                  ${ach.unlockedAt ? `<div style="font-size: 0.7rem; color: #64748b; margin-top: 6px;">Kazanıldı: ${ach.unlockedAt}</div>` : ''}
                </div>
              </div>
            `).join('')}
          </div>

          ${totalAchPages > 1 ? `
          <div style="display: flex; justify-content: center; gap: 12px; margin-top: 24px; align-items: center;">
            <button id="ach-prev-btn" ${this.achPage === 1 ? 'disabled' : ''} style="padding: 8px 16px; border-radius: 6px; background: #334155; color: #f8fafc; border: none; font-weight: 600; cursor: ${this.achPage === 1 ? 'not-allowed' : 'pointer'}; opacity: ${this.achPage === 1 ? '0.5' : '1'};">Önceki</button>
            <span style="color: #cbd5e1; font-size: 0.95rem; font-weight: 600;">Sayfa ${this.achPage} / ${totalAchPages}</span>
            <button id="ach-next-btn" ${this.achPage === totalAchPages ? 'disabled' : ''} style="padding: 8px 16px; border-radius: 6px; background: #6366f1; color: #fff; border: none; font-weight: 600; cursor: ${this.achPage === totalAchPages ? 'not-allowed' : 'pointer'}; opacity: ${this.achPage === totalAchPages ? '0.5' : '1'};">Sonraki</button>
          </div>
          ` : ''}
        </div>
      </div>
    `;

    if (!document.getElementById('ach-tab-styles')) {
      const style = document.createElement('style');
      style.id = 'ach-tab-styles';
      style.innerHTML = `
        .ach-tab-btn { padding: 8px 18px; background: transparent; color: #94a3b8; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: all 0.2s ease; }
        .ach-tab-btn:hover { color: #f8fafc; background: rgba(148, 163, 184, 0.1); }
        .ach-tab-btn--active { background: linear-gradient(135deg, #6366f1, #a855f7); color: #fff; box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3); }
      `;
      document.head.appendChild(style);
    }

    // Avatar Picker Modal Trigger
    
    // Render QR Code
    if (user.id !== 'guest') {
      const qrCanvas = container.querySelector('#qr-canvas') as HTMLCanvasElement;
      if (qrCanvas) {
        QRCode.toCanvas(qrCanvas, user.tag, {
          width: 160,
          color: { dark: '#f8fafc', light: '#0f172a00' },
          margin: 1
        }).catch(err => console.error('QR Error', err));
      }

      // Fetch badges
      const loadBadges = async () => {
        if (ApiClient.isSupabase) {
          const { supabase } = await import('../../services/supabase');
          const { data } = await supabase.from('user_badges').select('*').eq('user_id', user.id);
          const list = container.querySelector('#badges-list');
          if (list) {
            if (!data || data.length === 0) {
              list.innerHTML = `
                <div style="background: rgba(30, 41, 59, 0.5); padding: 12px; border-radius: 12px; border: 1px dashed #475569; text-align: left; width: 100%;">
                  <p style="color: #cbd5e1; font-size: 0.9rem; font-weight: 600; margin-bottom: 6px;">Rozetler Nasıl Kazanılır?</p>
                  <ul style="color: #94a3b8; font-size: 0.8rem; margin: 0; padding-left: 16px; line-height: 1.5;">
                    <li>Farklı oyunlar oynayarak ilk skorlarınızı kaydedin.</li>
                    <li>Liderlik tablolarında üst sıralara tırmanın.</li>
                    <li>Oyun içindeki özel başarımları tamamlayın.</li>
                  </ul>
                </div>
              `;
            } else {
              list.innerHTML = data.map((b: any) => `<div style="background: rgba(99, 102, 241, 0.2); border: 1px solid #6366f1; padding: 6px 12px; border-radius: 20px; display: flex; align-items: center; gap: 6px;"><span style="font-size: 1.2rem;">${b.badge_icon}</span><span style="font-size: 0.85rem; font-weight: 700; color: #cbd5e1;">${b.badge_name}</span></div>`).join('');
            }
          }
        }
      };
      loadBadges();
    }

    container.querySelector('#change-avatar-btn')?.addEventListener('click', () => {
      this.showAvatarPickerModal(container);
    });

    container.querySelector('#tab-ach-unlocked')?.addEventListener('click', () => {
      this.achTab = 'unlocked';
      this.achPage = 1;
      this.render(container);
    });

    container.querySelector('#tab-ach-locked')?.addEventListener('click', () => {
      this.achTab = 'locked';
      this.achPage = 1;
      this.render(container);
    });

    container.querySelector('#ach-game-select')?.addEventListener('change', (e) => {
      this.activeAchGame = (e.target as HTMLSelectElement).value;
      this.achPage = 1;
      this.render(container);
    });

    container.querySelector('#ach-prev-btn')?.addEventListener('click', () => {
      if (this.achPage > 1) {
        this.achPage--;
        this.render(container);
      }
    });

    container.querySelector('#ach-next-btn')?.addEventListener('click', () => {
      if (this.achPage < totalAchPages) {
        this.achPage++;
        this.render(container);
      }
    });
  }

  private static showAvatarPickerModal(container: HTMLElement): void {
    const overlay = document.createElement('div');
    overlay.className = 'ad-interstitial-overlay';
    overlay.style.zIndex = '100000';

    overlay.innerHTML = `
      <div class="glass-panel" style="width: 90%; max-width: 520px; padding: 28px; border-radius: 20px; display: flex; flex-direction: column; gap: 20px; position: relative; background: #1e293b; border: 1px solid #334155;">
        <button id="close-avatar-modal" style="position: absolute; top: 16px; right: 20px; color: #94a3b8; font-size: 1.4rem;">&times;</button>
        
        <div style="text-align: center;">
          <h2 style="font-size: 1.5rem; font-weight: 800;" class="gradient-text">Avatarını Seç</h2>
          <p style="color: #94a3b8; font-size: 0.85rem; margin-top: 4px;">15 özel avatardan profilin için birini seç!</p>
        </div>

        <div style="display: grid; grid-template-columns: repeat(5, 1fr); gap: 12px; max-height: 300px; overflow-y: auto; padding: 6px;">
          ${AVATARS_LIST.map(
            (av) => `
            <div data-avatar-icon="${av.icon}" class="avatar-option-card" style="background: rgba(15, 23, 42, 0.8); border: 2px solid #334155; border-radius: 14px; padding: 12px 6px; text-align: center; cursor: pointer; transition: all 0.2s ease;" onmouseover="this.style.borderColor='#6366f1'; this.style.transform='scale(1.05)'" onmouseout="this.style.borderColor='#334155'; this.style.transform='none'">
              <div style="font-size: 2.4rem;">${av.icon}</div>
              <div style="font-size: 0.68rem; font-weight: 700; color: #cbd5e1; margin-top: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${av.name}</div>
            </div>
          `
          ).join('')}
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    overlay.querySelector('#close-avatar-modal')?.addEventListener('click', () => overlay.remove());

    overlay.querySelectorAll('[data-avatar-icon]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const icon = (e.currentTarget as HTMLElement).getAttribute('data-avatar-icon');
        if (icon) {
          AuthStore.updateAvatar(icon);
          ToastManager.show(`✨ AI Avatarınız güncellendi: ${icon}`, 'success');
          overlay.remove();
          this.render(container);
        }
      });
    });
  }
}

